//criar uma tela para votação que recebe o IdVotacao e pesCodigoGUID para identificar a pessoa que está votando, carrega os dados da votação e os dados da pessoa
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { CircularProgress } from '@mui/material'
import Countdown from '../../components/CountTime';

function Votar() {
    const { IdVotacao, pesCodigoGUID, origem } = useParams();

    const navigate = useNavigate();
    const [votacao, setVotacao] = useState(null);
    const [pessoa, setPessoa] = useState(null);
    const [votosRegistrados, setVotosRegistrados] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";

    const [votoComentario, setVotoComentario] = useState('');

    useEffect(() => {
        setIsLoading(true);
        axios
        .post(
            process.env.REACT_APP_API_URL +
            '/routes.php?metodo=obtemVotacoes',
            {
                IdVotacao: IdVotacao
            },
            {
                headers: {
                    'X-Access-Token': tokenAPI,
                    'Content-Type': 'application/json; charset=utf-8'
                }
            }
        )
        .then(response => {
            if(response.data) {
                setVotacao(response.data[0]);

                axios
                .post(
                    process.env.REACT_APP_API_URL + '/routes.php?metodo=obtemCadastroAssociado',
                    {
                        IdPessoa: 0,
                        pesEmail: "",
                        pesCodigoGUID: pesCodigoGUID,
                        associado: 99
                    },
                    {
                        headers: {
                            'X-Access-Token': tokenAPI,
                            'Content-Type': 'application/json; charset=utf-8'
                        }
                    }
                )
                .then(responsePes => {
                    if (responsePes.data) {
                        setPessoa(responsePes.data);

                        axios
                        .post(
                            process.env.REACT_APP_API_URL + '/routes.php?metodo=ObtemVotosRegistrados',
                            JSON.stringify(
                                { 
                                    IdVotacao: IdVotacao, 
                                    IdPessoa: responsePes.data.IdPessoa 
                                }),
                            {
                                headers: {
                                    'X-Access-Token': tokenAPI,
                                    'Content-Type': 'application/json; charset=utf-8'
                                }
                            }
                        )
                        .then(response => {
                            if (response.data) {
                                setVotosRegistrados(response.data);
                                setIsLoading(false);
                            }
                        })
                        .catch(error => {
                            console.error('Erro ao buscar votos registrados:', error);
                            alert('Erro ao buscar votos registrados.');
                            setIsLoading(false);
                        });
                    }
                })
                .catch(error => {
                    console.error('Erro ao buscar dados da pessoa:', error);
                    alert('Erro ao buscar dados da pessoa.');
                    setIsLoading(false);
                });
            } else {
                alert('Votação não encontrada.');
                setIsLoading(false);
                navigate('/Votacoes');
            }
            setIsLoading(false);
        })
        .catch(error => {
            console.error('Erro ao buscar dados da votação:', error);
            alert('Erro ao buscar dados da votação.');
            setIsLoading(false);
            navigate('/Votacoes');
        });
    },[IdVotacao, tokenAPI, origem])

    function handleFecharModal() {
        //console.log(origem); return;
        if ((votacao.vtcOpcao === undefined 
            || votacao.vtcOpcao === null 
            || votacao.vtcOpcao === '') && votosRegistrados && votosRegistrados.length === 0) {
            if(!window.confirm('Opção de Voto não apontada.\n\nSair mesmo assim?')) {
                handleScrollToOptions();
                return;
            }
        }
        if (origem === 'votacoes')
            window.location.href = '/#/Votacoes';
        else if (origem === 'areaDoAssociado')
            window.location.href = '/#/AreaDoAssociado';
        else
            window.location.href = '/#/';
    }

    function gravaVoto(opcao) {
        this && this.preventDefault();

        const votoRegistrado = {
            IdVotacao: votacao.IdVotacao,
            IdPessoa: pessoa.IdPessoa,
            vtrDataVoto: new Date()
                .toLocaleDateString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                    }),
            vtrCriadoPor: pessoa.pesNome,
            vtrCriadoEm: new Date()
                .toLocaleDateString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                    }),
            vtrAlteradoPor: pessoa.pesNome,
            vtrAlteradoEm: new Date()
                .toLocaleDateString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                    }),
            vtrCodigoGUID: crypto.randomUUID()
        };

        //adicionar votoRegistrado ao array de votos registrados
        votosRegistrados.push(votoRegistrado);

        const uuidVot = crypto.randomUUID().slice(0, -12) + pessoa.pesCodigoGUID.slice(-12);

        const votoComputado = {
            IdVotacao: votacao.IdVotacao,
            IdPessoa: parseInt(votacao.vtcSecreto) === 0 ? pessoa.IdPessoa : 0,
            vtcOpcao: opcao,
            vtcComentario: votoComentario,
            vtcDataComputado: new Date()
                .toLocaleDateString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                    }),
            vtcCodigoGUID: uuidVot
        };

        //console.log('votoComputado:', votoComputado); return;
        axios
        .post(process.env.REACT_APP_API_URL
            + '/routes.php?metodo=ComputaVoto',
            votoComputado,{
                headers: {
                    'X-Access-Token': tokenAPI,
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }
        )
        .then(response => {
            if(response.data.success === true){
                console.log('Voto computado com sucesso:', response.data);

                axios
                .post(process.env.REACT_APP_API_URL
                    + '/routes.php?metodo=RegistraVoto',
                    votoRegistrado,{
                        headers: {
                            'X-Access-Token': tokenAPI,
                            'Content-Type': 'application/json; charset=UTF-8'
                        }
                    }
                )
                .then(response => {
                    if(response.data.success === true){
                        alert('\nOBRIGADO PELA SUA PARTICIPAÇÃO!\n\nVoto registrado com sucesso!');
                        enviarEmailConfirmacao(votoComputado);
                        marcarParticipacao();
                        handleFecharModal();
                    } else {
                        alert('Erro ao registrar o voto: ' + JSON.stringify(response.data));
                        window.location.href = '/';
                    }
                })
                .catch(error => {
                    alert('Erro ao registrar o voto: ' + JSON.stringify(error));
                    //window.location.href = '/';
                    handleFecharModal();
                });
            } else {
                alert('Erro ao computar o voto: ' + JSON.stringify(response.data));
                //window.location.href = '/';
                handleFecharModal();
            }
        })
        .catch(error => {
            alert('Erro ao computar o voto: ' + JSON.stringify(error));
            //window.location.href = '/';
            handleFecharModal();
        });

        //console.log(`Voto gravado para a opção: ${opcao}`);
        // Aqui você pode adicionar a lógica para enviar o voto para a API
    }

    function enviarEmailConfirmacao(votoComputado) {
        var corpoEmail = `
            <div style="margin: 0px; width: 100vw; height: 100vh; color: white; background-color: black; font-family: Arial, Helvetica, sans-serif;">
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <img width="200px" src="https://www.brasilextremos.com.br/api/uploads/fotos/logo_mgbe.png" alt="logoMGBE"/>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        Caro ${pessoa.pesNome}, agradecemos sua participação. 
                        <br /><br />
                        Seu voto foi registrado com sucesso!
                        <br/><br />
                        ${votacao.assDescricao && votacao.assDescricao !== '' ? `Votação da Assembleia: ${votacao.assDescricao} <br />` : ''} 
                        Sua escolha foi: ${votoComputado.vtcOpcao}
                        <br/>
                        <br/>
                        Esse email é a confirmação do seu voto, e não deve ser compartilhado com terceiros.
                        <br />
                        Em caso de dúvidas, entre em contato com a administração.
                        <br />
                        Esse email também pode ser utilizado como comprovante de participação na votação e em casos de auditoria.
                    </div>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        DATA DO VOTO: ${votoComputado.vtcDataComputado}
                        <br /><br />
                        CHAVE DE AUTENTICAÇÃO: ${votoComputado.vtcCodigoGUID}
                    </div>
                </div>
                
                <hr />
                <div style="font-size: 12px; color: #c1bbbb; padding: 10px;">
                    O conteúdo desse e-mail é destinado apenas ao destinatário.<br />
                    Seu conteúdo é classificado como confidencial e não deve ser divulgado, copiado ou distribuído a terceiros sem autorização.<br />
                    A violação de confidencialidade e privacidade com base nas Leis de Proteção de Dados, de Propriedade Intelectual e de Regulação de Uso da Internet pode resultar em responsabilidade civil e criminal.<br />
                    Agradecemos sua compreensão e cooperação.<br />
                    <p> Se você recebeu este e-mail por engano, por favor, notifique o remetente e exclua-o imediatamente.</p>
                </div>
            </div>
            `;
        const dadosEmail = {
            "email": pessoa.pesEmail,
            "assunto": 'MGBE - Confirmação de Voto',
            "mensagem": corpoEmail
        };
        axios
        .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=enviarEmail', 
            dadosEmail,
            {
                headers: 
                {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=utf-8"
                }
            }
        )
        .then(response => {
            console.log('Resposta do envio de email para ' + pessoa.pesEmail + ':', response.data);
            if (response.data.message === 'E-mail enviado com sucesso!') {
                console.log('Email enviado para ' + pessoa.pesEmail);
            } else {
                console.log('Erro ao enviar email para ' + pessoa.pesEmail);
            }
        })
        .catch(error => {
            alert(`Houve um erro ao enviar o email`);
        });
    }

    function marcarParticipacao() {
        try {
        // Lógica para marcar a participação do usuário
        // na const votacao tem a propriedade vtcParticipantes, nela tem os Ids das pessoas que já votaram e se não tiver o IdPessoa da pessoa atual precisa ser adicionado, esses IdPessoa estão separados por ponto e virgula
        const idPessoaAtual = pessoa.IdPessoa;
        const participantes = votacao.vtcParticipantes ? votacao.vtcParticipantes.split(';').map(id => parseInt(id)) : [];
        if (!participantes.includes(idPessoaAtual)) {
            participantes.push(idPessoaAtual);
            votacao.vtcParticipantes = participantes.join(';');
        }
        } catch(error){
            console.error('Erro ao marcar participação:', error);
        }
        //atualizar votacao na base

        axios
            .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=atualizarVotacao', 
                votacao,
                {
                    headers: 
                    {
                        "X-Access-Token" : tokenAPI,
                        "Content-Type": "application/json; charset=utf-8"
                    }
                }
            )
            .then(response => {
                console.log('Votação atualizada com sucesso:', response.data);
            })
            .catch(error => {
                console.error('Erro ao atualizar votação:', error);
            });
    }

    function handleScrollToOptions() {
        const element = document.getElementById('votingOptions');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    const paletaCores = [
        '#4D96FF', // Azul
        '#6BCB77', // Verde
        '#FFD93D', // Amarelo
        '#FF6B6B', // Vermelho suave
    ];

    //console.log('votoComentario:', votoComentario);

    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div>
                    {/* fechar */}
                    <div className='w100 text-align-center'>
                        <div className='text-align-center w100 fs16'>
                            <label className='w100 text-align-center'>
                                <button
                                    className="buttonModalVoltarLaranja fs11"
                                    onClick={handleFecharModal}>FECHAR
                                </button>
                            </label>
                        </div>
                    </div>
                        {isLoading ? ( 
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                                <CircularProgress />
                            </div>
                        ) : votacao ? (
                            <div>
                                <div>
                                    {/* ao tocar nesse titulo corre a tela até a seção de opções de votação */}
                                    <div className="headerMain w100" onClick={() => handleScrollToOptions()}>
                                        <label className='labelTitulo fs14 mt2' 
                                            style={{ cursor: 'pointer', 
                                            backgroundColor: '#7e7e7e', 
                                            padding: '5px', 
                                            borderRadius: '5px' }}>
                                            REGISTRAR MEU VOTO
                                        </label>
                                    </div>
                                    
                                    <div className="d-flex w100 flex-column tdAlignLeft pb4">
                                        {/* Titulo da votacao */}
                                        <div className="d-flex flex-row divForm">
                                            <div className="w100">
                                                <div className="text-align-center w100 divForm fs12 clrOrange">
                                                    <label><b>OBJETIVO</b></label>
                                                </div>
                                                <div className="text-align-center divForm w100 fs12 mt1 pl2 pr2">
                                                    <label
                                                        className="fs12 w100 text-align-left"
                                                        name="vtcTitulo"
                                                        id="vtcTitulo"
                                                        style={{
                                                            width: '100%',
                                                            padding: '8px',
                                                        }}
                                                    >
                                                        {votacao.vtcTitulo}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Descrição da votação */}
                                        <div className="d-flex w100 flex-row divForm">
                                            <div className="w100">
                                                <div className="text-align-center w100 mt1 divForm fs12 clrOrange">
                                                    <label><b>DESCRIÇÃO</b></label>
                                                </div>
                                                <div className="text-align-center divForm w100 fs12 mt1 pl2 pr2">
                                                    <label
                                                        className="w100 text-align-left"
                                                        name="vtcDescricao"
                                                        id="vtcDescricao"
                                                        style={{
                                                            width: '100%',
                                                            padding: '8px',
                                                        }}
                                                    >
                                                        {votacao.vtcDescricao}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {/* DataFinal de Votação */}
                                        <div className="d-flex flex-row divForm mt2">
                                            <div className="w100">
                                                <div className="text-align-center divForm w100 fs12 clrOrange">
                                                    <label><b>Data Final de Votação: {new Date(votacao.vtcDataFinal).toLocaleDateString('pt-BR', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                        }).replace(',', ' às')}</b>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Contagem regressiva para o término da votação */}
                                        <div style={{ marginTop: '16px', marginBottom: '16px' }}>
                                        {votacao && votacao.vtcPosicao === "ANDAMENTO" && (
                                            <Countdown targetDate={new Date(votacao.vtcDataFinal)} />
                                        )}
                                        </div>

                                        <hr style={{ width: '100%', marginTop: '16px', marginBottom: '16px' }}/>
                                        
                                        {
                                            (!votosRegistrados || votosRegistrados.length === 0) 
                                            && parseInt(votacao.vtcComentar) === 1 ?
                                            (
                                                <div className="text-align-center divForm fs12 ">
                                                    <label className="clrOrange"><b>Deixe um comentário (opcional)</b></label>
                                                    <textarea 
                                                        className="w100 mt1 fs12" 
                                                        rows="4" 
                                                        onChange={(e) => setVotoComentario(e.target.value)} 
                                                        value={votoComentario} 
                                                        placeholder="Escreva seu comentário aqui...">
                                                    </textarea>
                                                </div>
                                            ) : null
                                        }
                                        {/* vtcOpcoes é um texto em que as opções de votação estão separadas por ponto e virgula, precisa apresentar um botão para cada uma dessas opções */}
                                        <div id="votingOptions" className="w100 text-align-center">
                                            <div className=" w100 text-align-center">
                                                <div className="text-align-center fs12 clrOrange">
                                                    <label><b>{votosRegistrados && votosRegistrados.length > 0 ? ('') : ('Opções de Voto')}</b></label>
                                                </div>
                                            </div>
                                        </div>
                                        {/* quando for clicado em uma opção deve exibir uma confirmação exibindo o nome da opção selecionada, e opção para confirmar o voto ou alterar a escolha */}
                                        {
                                            votosRegistrados && votosRegistrados.length > 0 ? (
                                                <div className="text-align-center divForm fs12 w100">
                                                    <label><i><b>Você ja participou nessa votação!</b></i></label>
                                                    <br /><br />
                                                    <Link to={`/resultado/${votacao.IdVotacao}`} style={{ textDecoration: 'none', color: 'orange', fontSize: '20px' }}>
                                                        <label><i><b>ACOMPANHE O RESULTADO AQUI !</b></i></label>
                                                    </Link>
                                                </div>
                                            ) : votacao.vtcPosicao === "FINALIZADO" ? (
                                                <div className="text-align-center divForm fs12 w100">
                                                    <label><i><b>Votação Encerrada</b></i></label>
                                                </div>
                                            ) : votacao.vtcPosicao === "CANCELADO" ? (
                                                <div className="text-align-center divForm fs12 w100">
                                                    <label><i><b>Votação Cancelada</b></i></label>
                                                </div>
                                            ) : votacao.vtcPosicao === "AUDITANDO" ? (
                                                <div className="text-align-center divForm fs12 w100">
                                                    <label><i><b>Votação em Auditoria</b></i></label>
                                                </div>
                                            ) : votacao.vtcPosicao === "ANDAMENTO" && new Date(votacao.vtcDataFinal) < new Date() ? (
                                                <div className="text-align-center divForm fs12 w100">
                                                    <label><i><b>Votação Encerrada</b></i></label>
                                                </div>
                                            ) : (
                                                votacao.vtcOpcoes.split(';').map((opcao, index) => 
                                                    <div className="d-flex flex-row mt1 w100 text-align-center">
                                                        <div className='text-align-center mb1 divForm fs14'>
                                                            <button 
                                                                key={index} 
                                                                className='buttonVotoPadrao w100 fs12' 
                                                                style={{ backgroundColor: paletaCores[index % paletaCores.length] }} 
                                                                title={`Votar na opção: ${opcao}`} 
                                                                onClick={() => 
                                                                { 
                                                                    if(window.confirm(`\n\nVocê votou na opção:
                                                                    \n\n ${opcao} 
                                                                    \n\n CONFIRMA SEU VOTO?`)) 
                                                                    { gravaVoto(opcao) } }}>
                                                                {opcao}
                                                            </button>
                                                        </div>
                                                    </div>
                                                )
                                            )
                                        }
                                        
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <></>
                        )}
                </div>
            </main>
        </div>
    );
}

export default Votar;
